// How each browser words a code-split file that failed to load (gone after a deploy, or HTML in its place).
const PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chrome
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /Unable to preload CSS/i, // Vite's CSS preload
  /Expected a JavaScript.* module script/i,
  /ChunkLoadError|Loading (CSS )?chunk .* failed/i,
]

const message = (error: unknown) => (error instanceof Error ? `${error.name}: ${error.message}` : String(error))

/** True when `error` means the running build's files are no longer served (a new version was deployed). */
export function isChunkLoadError(error: unknown): boolean {
  const text = message(error)
  return PATTERNS.some((p) => p.test(text))
}

/** The asset URL named in the error, when the browser includes it (Chrome and Firefox do). */
export function failedAssetUrl(error: unknown): string | undefined {
  return message(error).match(/https?:\/\/[^\s'"]+\/assets\/[^\s'"]+\.(?:js|css)/)?.[0]
}
